import useServices from '../models/useServices'
import ServiceForm, { ServiceFormData } from './ServiceForm'
import { SERVICE_FORBIDDEN, toolRefusalMessage } from '../utilities/routerWrites'

interface Props {
  nodeId?: string
  nodeName?: string
  type?: ServiceType
  onTypeChange: (type: ServiceType) => void
  onSuccess?: () => void
}

export default function AddService({ nodeId, nodeName, type = 'web', onTypeChange, onSuccess }: Readonly<Props>) {
  const publish = useServices(s => s.publish)

  // ⚠ The form closes only when the service exists. A refusal stays on screen as one sentence.
  const handleCreate = async (data: ServiceFormData): Promise<string | null> => {
    if (!nodeId) return 'This node is not loaded yet. Try again in a moment.'
    try {
      await publish(nodeId, data)
    } catch (e) {
      console.error('service_publish failed:', e)
      return toolRefusalMessage(e, SERVICE_FORBIDDEN, 'Could not create the service.')
    }
    onSuccess?.()
    return null
  }

  return (
    <ServiceForm
      nodeId={nodeId}
      nodeName={nodeName}
      title="New Service"
      serviceType={type}
      hideTypeChange={false}
      onTypeChange={onTypeChange}
      actionButton={{
        label: 'Create Service',
        onClick: handleCreate,
      }}
      onCancel={() => onSuccess?.()}
    />
  )
}
